import { AdminHome } from "@widgets/adminPanel";
import { FC } from "react";

export const AdminHomePage: FC = () => {
  return <AdminHome />;
};
